module.exports = __webpack_public_path__ + "static/media/heroku.4f00c939.png";